/* eslint-disable react/prop-types */
import { Edit, Add, ExpandMore } from '@mui/icons-material';
import { Box, Button, Grid, Typography, Divider, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { IConstructiveProject } from '../../services/api/constructive-project/ConstructiveProjectServices';
import { IConstructiveSteps } from '../../services/api/constructive-project/ConstructiveStepsServices';

interface ICharacteristicsProject {
  dataProject?: IConstructiveProject;
  dataSteps: IConstructiveSteps[];
  handleEdit: () => void;
  handleNew: () => void;
  permissions?: string;
  hasAddPermission?: boolean;
  hasEditPermission?: boolean;
}

export const CharacteristicsProject: React.FC<ICharacteristicsProject> = ({
  dataProject,
  dataSteps,
  handleEdit,
  handleNew,
  // permissions,
  hasAddPermission = false,
  hasEditPermission = false,
}) => {
  return (
    <Box width='100%'>
      <Box>
        {/* <Box width='100%' paddingY={1}> */}
        {/* {permissions.includes('add') || permissions.includes('edit') ? */}
        {/* <Button variant='contained' */}
        {/* onClick={dataProject != undefined ? handleEdit : handleNew} */}
        {/* sx={{ borderRadius: '25px' }} */}
        {/* startIcon={dataProject != undefined ? <Edit /> : <Add />}> */}
        {/* {dataProject != undefined ? 'Editar Características' : 'Cadastrar Projeto'} */}
        {/* </Button> */}
        {/* : null */}
        {/* } */}
        {/* </Box> */}
        <Box width='100%' paddingY={1}>
          {dataProject?.uuid ? (
            hasEditPermission && (
              <Button
                variant='contained'
                onClick={handleEdit}
                sx={{ borderRadius: '25px' }}
                startIcon={<Edit />}
              >
                Editar Características
              </Button>
            )
          ) : (
            hasAddPermission && (
              <Button
                variant='contained'
                onClick={handleNew}
                sx={{ borderRadius: '25px' }}
                startIcon={<Add />}
              >
                Cadastrar Projeto
              </Button>
            )
          )}
        </Box>
        {
          dataProject?.uuid ? (
            <>
              <Grid container display='flex'>
                <Grid container item marginY={1}>
                  <Grid item xs={6}>
                    <Typography>Histórico construtivo:</Typography>
                  </Grid>
                  <Grid item xs={6} >
                    <Typography>{dataProject?.historico_construtivo}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </Grid>
                <Grid container item marginY={1}>
                  <Grid item xs={6}>
                    <Typography>Método construtivo:</Typography>
                  </Grid>
                  <Grid item xs={6} >
                    <Typography>{dataProject?.metodo_construtivo}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </Grid>
                <Grid container item marginY={1}>
                  <Grid item xs={6}>
                    <Typography>Quantidade de etapas/alteamentos previstos:</Typography>
                  </Grid>
                  <Grid item xs={6} >
                    <Typography>{dataProject?.quantidade_etapas_previstas}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </Grid>
                <Grid container item marginY={1}>
                  <Grid item xs={6}>
                    <Typography>Quantidade de etapas/alteamentos executados:</Typography>
                  </Grid>
                  <Grid item xs={6} >
                    <Typography>{dataProject?.quantidade_etapas_executadas}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                </Grid>
              </Grid>
              <Box paddingY={1}>
                {dataSteps.map((item, index) => (
                  <Box width='100%' paddingY={1} key={item.uuid}>
                    <Accordion key={item.uuid} variant='outlined'>
                      <AccordionSummary expandIcon={<ExpandMore />}>
												<Typography>Etapa construtiva {index + 1}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container>
                          <Grid item container>
                            <Grid item xs={6}>
                              <Typography>Elevação (m):</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography>{item.elevacao ? item.elevacao : 'Não informado'}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
                              <Typography>Empresa projetista:</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography>{item.empresa_projetista ? item.empresa_projetista : 'Não informado'}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>RT de projeto:</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>{item.rt_projeto ? item.rt_projeto : 'Não informado'}</Typography>
                              
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>Ano do projeto:</Typography>
                              
                            </Grid>
                            <Grid item xs={6}>
															<Typography>{item.ano_projeto ? item.ano_projeto : 'Não informado'}</Typography>
                              
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>Empresa construtora:</Typography>
                              
                            </Grid>
                            <Grid item xs={6}>
															<Typography>{item.empresa_construtora ? item.empresa_construtora : 'Não informado'}</Typography>
                              
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography> RT de obra:</Typography>
                             
                            </Grid>
                            <Grid item xs={6}>
															<Typography>
                              {item.rt_obra ? item.rt_obra : 'Não informado'}

															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>
                              Empresa Fiscalizadora (ATO):

															</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>

                              {item.empresa_fiscalizadora_ato ? item.empresa_fiscalizadora_ato : 'Não informado'}
															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>

                              RT de Fiscalização/ ATO:
															</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>

                              {item.rt_fiscalizacao_ato ? item.rt_fiscalizacao_ato : 'Não informado'}
															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>

                              Ano de construção:
															</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>
                              {item.ano_construcao ? item.ano_construcao : 'Não informado'}

															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>

                              As Built ou As Is:
															</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>
                              {item.as_built_as_is ? item.as_built_as_is : 'Não informado'}

															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>

                              Empresa executora As Built ou As Is:
															</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>

                              {item.empresa_executora_as_built_as_is ? item.empresa_executora_as_built_as_is : 'Não informado'}
															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                          <Grid item container>
                            <Grid item xs={6}>
															<Typography>

                              Ano As Built ou As Is:
															</Typography>
                            </Grid>
                            <Grid item xs={6}>
															<Typography>

                              {item.ano_as_built_as_is ? item.ano_as_built_as_is : 'Não informado'}
															</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                ))}
              </Box>
            </>
          ) : (<></>)
        }
      </Box >
    </Box >
  );
};